// Design System 2.0 (2026-10, Phase 1) — presentational only, unused by any page yet
// (page-level swaps happen in their own phases). Covers both documented shapes: the inline
// 6-bar glyph (used everywhere except Project Detail) and the full stepper (Project Detail only).
export const STAGES = ["Brief Received", "Confirmed", "Pre-production", "Production", "Post-production", "Completed"];

function stageIndex(stage) {
  if (!stage) return -1;
  const i = STAGES.findIndex((s) => s.toLowerCase() === stage.toString().trim().toLowerCase());
  return i;
}

/** Six 8x4 bars: done = ink, current = yellow, upcoming = hairline. Always labelled "Stage". */
export function StageGlyph({ stage, testId }) {
  const current = stageIndex(stage);
  return (
    <span data-testid={testId} className="inline-flex items-center gap-2">
      <span className="inline-flex items-center gap-0.5">
        {STAGES.map((s, i) => (
          <span
            key={s}
            data-testid={testId ? `${testId}-bar-${i}` : undefined}
            className={`h-1 w-2 rounded-[1px] ${i < current ? "bg-ink" : i === current ? "bg-brand" : "bg-hairline"}`}
          />
        ))}
      </span>
      <span className="text-xs text-ink-soft">Stage: {current >= 0 ? STAGES[current] : stage || "—"}</span>
    </span>
  );
}

/** Horizontal labeled stepper for Project Detail. done = ink, current = yellow ring +
 * "In progress", upcoming = hairline outline. */
export function StageStepper({ stage, testId }) {
  const current = stageIndex(stage);
  return (
    <div data-testid={testId} className="flex items-center" aria-label={`Stage: ${current >= 0 ? STAGES[current] : stage || "unknown"}`}>
      {STAGES.map((s, i) => {
        const done = i < current;
        const isCurrent = i === current;
        return (
          <div key={s} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-1.5 shrink-0" data-testid={testId ? `${testId}-step-${i}` : undefined}>
              <span
                className={`h-2.5 w-2.5 rounded-full shrink-0 ${
                  done ? "bg-ink" : isCurrent ? "bg-brand ring-[3px] ring-brand/30" : "bg-paper border border-hairline"
                }`}
              />
              <span className={`text-[11px] whitespace-nowrap ${isCurrent ? "text-ink font-semibold" : done ? "text-ink-soft" : "text-faint"}`}>
                {s}{isCurrent && <span className="ml-1 text-gold-text">· In progress</span>}
              </span>
            </div>
            {i < STAGES.length - 1 && <div className={`h-px flex-1 mx-2 ${done ? "bg-ink" : "bg-hairline"}`} />}
          </div>
        );
      })}
    </div>
  );
}
